<template lang="html">
  <v-container fill-height>
      <v-layout align-center justify-center>
        <v-flex xs10>
          <!-- Content goes inside a card for better adjustment -->
          <v-card class="text-xs-center">
            <basic-toolbar :title="'404'"></basic-toolbar>
            <v-card-text>
              Página não encontrada
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" block text @click="$router.go(-1)">Voltar</v-btn>
          </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
  </v-container>
</template>

<script>
import BasicToolbar from '@/components/toolbars/basic-toolbar'

export default {
  components: {
    'basic-toolbar': BasicToolbar
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// 404.vue?79257fb0